import { Grid } from '@material-ui/core';
import React from 'react';
import { styles } from './action-window-styles';
import { ItemTaxViewData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { hasTaxItemFee, hasTaxTransactionFee } from '../business-logic/action-window-actions';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { useTranslation } from 'react-i18next';

const ItemFees: React.FC<TaxProps> = (taxProps: TaxProps): JSX.Element => {
  const { taxes } = taxProps;
  const classes = styles({});
  const { t } = useTranslation();

  return (
    <>
      {taxes.map(tax => {
        if (hasTaxItemFee(tax) || hasTaxTransactionFee(tax)) {
          return (
            <Grid
              key={tax.lineId}
              container
              className={`${classes.itemFeeLine} ${classes.paddingTop}`}
            >
              <Grid item>
                <span data-testid='item-fee-name'>{tax.code || t('ItemFeeName_Default')}</span>
              </Grid>
              <Grid item className={classes.autoLeftMargin}>
                <span data-testid='item-fee-amount'>{`${convertCurrency(tax.amount)}`}</span>
              </Grid>
            </Grid>
          );
        } else {
          return null;
        }
      })}
    </>
  );
};
export interface TaxProps {
  taxes: ItemTaxViewData[];
}

export default ItemFees;
